export default __webpack_public_path__ + "static/2462-7fd7e049a9c1542b4e7f0d320a086518.gif";